import { render, staticRenderFns } from "./CostCollect.vue?vue&type=template&id=71800220&scoped=true&"
import script from "./CostCollect.vue?vue&type=script&lang=js&"
export * from "./CostCollect.vue?vue&type=script&lang=js&"
import style0 from "./CostCollect.vue?vue&type=style&index=0&id=71800220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71800220",
  null
  
)

export default component.exports